import { useRef } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import HowItWorks from "@/components/site/HowItWorks";
import Benefits from "@/components/site/Benefits";
import ServiceAreas from "@/components/site/ServiceAreas";
import LeadFormSection from "@/components/site/LeadFormSection";
import Faq from "@/components/site/Faq";
import Footer from "@/components/site/Footer";

export default function Landing() {
  const formRef = useRef(null);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#F9F8F6] pb-24 lg:pb-0">
      <Header onCtaClick={scrollToForm} />
      <main>
        <Hero onCtaClick={scrollToForm} />
        <HowItWorks />
        <Benefits />
        <LeadFormSection forwardedRef={formRef} />
        <ServiceAreas />
        <Faq />
      </main>
      <Footer />

      {/* Sticky mobile CTA */}
      <div
        data-testid="sticky-mobile-cta"
        className="lg:hidden fixed bottom-4 left-4 right-4 z-40"
      >
        <button
          onClick={scrollToForm}
          className="tr-btn-primary w-full rounded-full h-14 font-medium text-base shadow-2xl"
        >
          Get My Cash Offer
        </button>
      </div>
    </div>
  );
}
